<template>
  <router-link v-if="to" ref="button" :class="classes" :to="to">
    <slot />
  </router-link>
  <button
    v-else
    ref="button"
    :class="classes"
    :style="{ width: fixedWidth }"
    :type="type"
    :disabled="disabled"
    @click="click"
  >
    <span v-if="loading" class="loading-spinner" />
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    to: {
      type: [String, Object],
      default: () => undefined
    },
    slim: Boolean,
    disabled: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: () => undefined
    }
  },
  data () {
    return {
      fixedWidth: 'auto'
    }
  },
  computed: {
    classes () {
      return {
        button: true,
        'button-slim': this.slim,
        'button-loading': this.loading,
        'button-disabled': this.disabled
      }
    }
  },
  watch: {
    loading (loadingNow) {
      let ref = this.$refs.button
      if (ref.$el) {
        ref = ref.$el
      }

      if (loadingNow) {
        this.fixedWidth = `${ref.getBoundingClientRect().width}px`
      } else {
        this.fixedWidth = 'auto'
      }
    }
  },
  methods: {
    click (event) {
      if (!this.disabled && this.type === undefined) {
        event.preventDefault()
        this.$emit('click')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.button {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background: $primary;
  font-weight: bold;
  padding: 1rem;
  border: none;
  color: #edf5fa;
  text-align: center;
  font-size: 1rem;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  transition: box-shadow 0.1s ease-in-out;
  border-radius: 2px;
  text-decoration: none;
  display: inline-block;
  box-sizing: border-box;
  height: 3.125rem;
  line-height: 1rem;

  &:hover {
    cursor: pointer;
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2);
  }

  &:hover, &:active, &:focus {
    background: saturate($primary, 20%);
    outline: none;
  }

  &-disabled {
    background: desaturate($primary, 20%);

    &:hover, &:active, &:focus {
      cursor: initial;
      box-shadow: none;
      background: desaturate($primary, 20%);
    }
  }

  &-slim {
    padding: 0.75rem 1rem;
    height: 2.5rem;
  }

  &-loading {
    line-height: 1rem;
    padding: 0.75rem 1rem;
  }

  &-loading.button-slim {
    padding: 0.5rem 1rem;
  }

  .loading-spinner {
    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    display: inline-block;
    border: 0.25rem solid rgba(255, 255, 255, 0.3);
    border-top-color: rgba(255, 255, 255, 0.75);
    animation: 1.5s spin infinite linear;
  }
}
</style>
